<template>
  <div>
    <a-row>
      <a-col :span="4" />
      <a-col :span="14">
        <div style="font-size: large; margin-bottom: 20px">{{ buttontext }}通道组</div>

        <div style="display: flex; margin-top: 10px">
          <span style="width: 90px; flex: none; line-height: 28px">*通道组名称：</span>
          <a-input v-model="title" aria-required="true" placeholder="通道组名称不能重复！" />
        </div>

        <div style="display: flex; margin-top: 10px">
          <span style="width: 90px; flex: none; line-height: 28px">通道列表：</span>
          <a-collapse style="width: 100%">
            <a-collapse-panel v-for="(channel, index) in channelList" :key="index">
              <template slot="header">
                <div style="margin-left: 95%">
                  <a-icon type="plus-circle" style="margin-right: 30%" @click="addChannel()" />
                  <a-icon type="minus-circle" @click="subChannel(index)" />
                </div>
              </template>
              <ul style="margin-left: -5%">
                <li style="display: flex; margin-top: 10px">
                  <span style="width: 80px; flex: none; line-height: 28px">*通道名称：</span>
                  <a-spin :spinning="channelLoading">
                    <a-select v-model="channel.channel_id" style="width: 320px" @change="channelChange(index, channel)">
                      <a-select-option v-for="item in totalChannelList" :key="item.name" :value="item.id">
                        {{ item.name + ' (' + item.gateway + ')' }}
                      </a-select-option>
                    </a-select>
                  </a-spin>
                </li>
                <!-- 
                <li style="display:flex;margin-top:10px">
                  <span style="width: 80px;flex: none;line-height: 28px;">*通道id：</span>
                  <a-input v-model="channel.channel_id" aria-required="true"/>
                </li>

                <li style="display:flex;margin-top:10px">
                  <span style="width: 80px;flex: none;line-height: 28px;">*通道名称：</span>
                  <a-input v-model="channel.channel_name" aria-required="true"/>
                </li> -->

                <li style="display: flex; margin-top: 10px">
                  <span style="width: 80px; flex: none; line-height: 28px">*收件人：</span>
                  <a-collapse style="width: 100%">
                    <a-collapse-panel v-for="(receiver, receiverIndex) in channel.receiver" :key="receiverIndex">
                      <template slot="header">
                        <div style="margin-left: 95%">
                          <a-icon type="plus-circle" style="margin-right: 15%" @click="addReceiver(index)" />
                          <a-icon type="minus-circle" @click="subReceiver(index, receiverIndex)" />
                        </div>
                      </template>
                      <ul style="margin-left: -5%">
                        <li style="display: flex; margin-top: 10px">
                          <span style="width: 80px; flex: none; line-height: 28px">*Username：</span>
                          <a-input v-model="receiver.username" aria-required="true" />
                        </li>
                        <li v-if="channel.gateway === 'mail'" style="display: flex; margin-top: 10px">
                          <span style="width: 80px; flex: none; line-height: 28px">邮箱：</span>
                          <a-input v-model="receiver.email" aria-required="true" />
                        </li>
                        <li v-if="channel.gateway === 'mail'" style="display: flex; margin-top: 10px">
                          <span style="width: 80px; flex: none; line-height: 28px">是否是抄送人：</span>
                          <a-switch v-model="receiver.is_cc" />
                        </li>
                        <li v-if="channel.gateway === 'dingding'" style="display: flex; margin-top: 10px">
                          <span style="width: 80px; flex: none; line-height: 28px">
                            <a-tooltip>
                              <template slot="title"> 点击需要at用户的【用户头像】-【更多信息】-【钉钉号】 </template>
                              钉钉号：
                            </a-tooltip>
                          </span>
                          <a-input v-model="receiver.dingtalk_id" aria-required="true" />
                        </li>
                        <li v-if="channel.gateway === 'dingding'" style="display: flex; margin-top: 10px">
                          <span style="width: 80px; flex: none; line-height: 28px">手机号：</span>
                          <a-input v-model="receiver.phone" aria-required="true" />
                        </li>
                      </ul>
                    </a-collapse-panel>
                  </a-collapse>
                </li>
              </ul>
            </a-collapse-panel>
          </a-collapse>
        </div>

        <div class="editor-button-box">
          <a-button @click="finishCreate" label="submit" v-if="this.pageType !== 'show'">{{ buttontext }}通道</a-button>
        </div>
      </a-col>
      <a-col :span="4" />
    </a-row>
  </div>
</template>

<script>
import { getChannelList, updateChannelGroup, createChannelGroup, getSingleChannelGroup } from '@/api/notice'

export default {
  data() {
    return {
      buttontext: '创建',
      title: '',
      noticeVisible: false,
      pageType: 'create',
      totalChannelList: [],
      channelLoading: true,
      channelList: [
        {
          channel_id: '',
          channel_name: '',
          gateway: '',
          receiver: [
            {
              username: '',
              email: '',
              is_cc: false,
              phone: '',
              dingtalk_id: ''
            }
          ]
        }
      ]
    }
  },
  created() {
    this.pageType = this.$route.query.type
    this.id = this.$route.query.id
    this.getTotalChannelList()
    if (this.pageType === 'update' || this.pageType === 'show') {
      if (this.pageType === 'show') {
        this.buttontext = ''
      }
      if (this.pageType === 'update') {
        this.buttontext = '更新'
      }
      getSingleChannelGroup(this.id).then(res => {
        const data = res.data
        this.title = data.name
        this.channelList = data.channel_list
      })
    }
  },
  methods: {
    getTotalChannelList() {
      const params = {
        page_num: 1,
        page_size: 500
      }
      this.channelLoading = true
      getChannelList(params)
        .then(res => {
          this.totalChannelList = res.data.list
          this.channelLoading = false
        })
        .catch(() => {
          this.totalChannelList = []
          this.channelLoading = false
        })
    },
    channelChange(index, channel) {
      const findObj = this.totalChannelList.find(each => each.id === channel.channel_id)
      this.channelList[index].channel_name = findObj.name
      this.channelList[index].gateway = findObj.gateway
    },
    addChannel() {
      this.channelList.push({
        channel_id: '',
        channel_name: '',
        gateway: '',
        receiver: [
          {
            username: '',
            email: '',
            is_cc: false,
            phone: '',
            dingtalk_id: ''
          }
        ]
      })
    },
    //减号
    subChannel(index) {
      if (this.channelList.length !== 1) {
        this.channelList.splice(index, 1)
      }
    },
    addReceiver(index) {
      this.channelList[index].receiver.push({
        username: '',
        email: '',
        is_cc: false,
        phone: '',
        dingtalk_id: ''
      })
    },
    //减号
    subReceiver(index, recindex) {
      console.log(this.channelList[index])
      if (this.channelList[index].receiver.length !== 1) {
        this.channelList[index].receiver.splice(recindex, 1)
      }
    },
    finishCreate() {
      if (!this.title) {
        this.$message.warning('通道组名称不能为空！', 2)
        return
      }
      if (this.title.length > 32 || this.title.length < 4) {
        this.$message.warning('通道组名称过短！', 2)
        return
      }
      for (const channel of this.channelList) {
        if (!channel.channel_id && !channel.channel_name) {
          this.$message.error('通道id和通道名至少填一个！')
          return
        }
      }
      const params = {
        name: this.title,
        channel_list: this.channelList
      }
      console.log(params)
      let method = this.pageType === 'update' ? updateChannelGroup : createChannelGroup
      method(this.id, params)
        .then(() => {
          this.$message.success(`${this.pageType === 'update' ? '更新' : '创建'}成功`, 2)
          this.$router.push({ name: 'ChannelGroupManage' })
        })
        .catch(() => {
          this.$message.error(`${this.pageType === 'update' ? '更新' : '创建'}失败！信息填写有误！`, 2)
        })
    }
  }
}
</script>

<style scoped>
.editor-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.editor-button-box {
  margin-top: 20px;
  text-align: center;
}

.editor-button-box button {
  margin-right: 10px;
}
</style>
